import React from 'react';
import { Link, useParams } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import RewardTransactionTable from '../../Reward/RewardTransactions/TransactionTable';

import {
  Card,
  CardBody,
  CardHeader,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from 'reactstrap';

const RecentTransaction = ({}) => {
  let params = useParams();

  // const RecentTransaction = [
  //   {
  //     id: '1',
  //     date: 'Tue 19 Dec',
  //     time: '08:00 AM',
  //     transactionId: '132323232323',
  //     walletId: '21213323232',
  //     customerName: 'Abdul',
  //     description: 'Earned',
  //     descriptionNote: 'Store: Barsha, Ref: SO123456',
  //     amount: '+ 500 Nos',
  //     transactionType: 'Credited',
  //     feaIconClass: 'text-success',
  //     feaIcon: 'arrow-down-right',
  //     expDate: 'Tue 19 Jan 2024',
  //   },
  //   {
  //     id: '2',
  //     date: 'Tue 19 Dec',
  //     time: '08:20 AM',
  //     transactionId: '13232325444',
  //     walletId: '2333223232',
  //     customerName: 'Bari',
  //     description: 'Redeemed',
  //     descriptionNote: 'Store: danubehome.com, Ref: SO123476',
  //     amount: '- 100 Nos',
  //     transactionType: 'Debited',
  //     feaIconClass: 'text-danger',
  //     feaIcon: 'arrow-up-right',
  //   },
  //   {
  //     id: '3',
  //     date: 'Tue 19 Dec',
  //     time: '08:30 AM',
  //     transactionId: '13232325444',
  //     walletId: '2333223232',
  //     customerName: 'Sajeer K',
  //     description: 'Earned',
  //     descriptionNote: 'Store: Itc, Ref: SO129786',
  //     amount: '+ 500 Nos',
  //     transactionType: 'Credited',
  //     feaIconClass: 'text-success',
  //     feaIcon: 'arrow-up-right',
  //     expDate: 'Tue 19 Jan 2024',
  //   },
  //   {
  //     id: '4',
  //     date: 'Tue 19 Dec',
  //     time: '08:31 AM',
  //     transactionId: '13232325444',
  //     walletId: '2333223232',
  //     customerName: 'Rishal',
  //     description: 'Earned',
  //     descriptionNote: 'Store: danubehome.com, Ref: SO123456',
  //     amount: '+ 1000 Nos',
  //     transactionType: 'Credited',
  //     feaIconClass: 'text-success',
  //     feaIcon: 'arrow-up-right',
  //     expDate: 'Tue 19 Jan 2024',
  //   },
  //   {
  //     id: '5',
  //     date: 'Tue 19 Dec',
  //     time: '08:36 AM',
  //     transactionId: '13232325444',
  //     walletId: '2333223232',
  //     customerName: 'Akhil',
  //     description: 'Earned',
  //     descriptionNote: 'Store: danubehome.com, Ref: SO123456',
  //     amount: '+ 50 Nos',
  //     transactionType: 'Credited',
  //     feaIconClass: 'text-success',
  //     feaIcon: 'arrow-up-right',
  //     expDate: 'Tue 19 Jan 2024',
  //   },
  // ];
  return (
    <React.Fragment>
      <Card>
        <CardHeader className="align-items-center d-flex">
          <h4 className="card-title mb-0 flex-grow-1">Recent Transactions</h4>
          <div className="flex-shrink-0">
            <UncontrolledDropdown
              className="card-header-dropdown"
              direction="start"
            >
              <DropdownToggle tag="a" className="text-reset" role="button">
                <span className="fw-semibold text-uppercase fs-12">
                  Sort by:{'  '}
                </span>
                <span className="text-muted">
                  All <i className="mdi mdi-chevron-down ms-1"></i>
                </span>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-end">
                <DropdownItem>All</DropdownItem>
                <DropdownItem>Yesterday</DropdownItem>
                <DropdownItem>Paid</DropdownItem>
                <DropdownItem>Pending</DropdownItem>
                <DropdownItem>Canaled</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        </CardHeader>
        <CardBody>
          <RewardTransactionTable
            isShowLess={true}
            rewardTypeId={params?.path}
          />
        </CardBody>
        {/* <CardBody>
          <div className="table-responsive table-card">
            <table className="table table-hover table-centered align-middle table-nowrap mb-0">
              <thead>
                <tr>
                  <th></th>
                  <th>Date</th>
                  <th>Transaction ID</th>
                  <th>Ahlan ID</th>
                  <th>Description</th>
                  <th>Points</th>
                </tr>
              </thead>
              <tbody>
                {(RecentTransaction || []).map((item, key) => (
                  <tr key={key}>
                    <td>
                      <div className="d-flex align-items-center">
                        <div>
                          <h5 className="fs-13 my-1">{item.id}</h5>
                        </div>
                      </div>
                    </td>
                    <td>
                      <h5 className="fs-13 my-1 fw-normal">{item.date}</h5>
                      <span className="fs-10 text-muted">{item.time}</span>
                    </td>
                    <td>
                      <h5 className="fs-13 my-1 fw-normal">
                        #{item.transactionId}
                      </h5>
                    </td>
                    <td>
                      <h5 className="fs-13 my-1 fw-normal">#{item.walletId}</h5>
                      <span className="fs-10 text-muted">
                        {item.customerName}
                      </span>
                    </td>
                    <td>
                      <div className="d-flex gap-2">
                        <span className={`${item?.feaIconClass}`}>
                          <FeatherIcon
                            icon={item?.feaIcon}
                            style={{ width: 16 }}
                          />
                        </span>
                        <div>
                          <h5 className="fs-13 my-1 fw-normal">
                            {item.description}
                          </h5>
                          <p className="fs-10 mb-0 text-muted">
                            {item.descriptionNote}
                          </p>
                          {item.expDate ? (
                            <p className="fs-10 mb-0 text-warning">
                              Expired on {item.expDate}
                            </p>
                          ) : null}
                        </div>
                      </div>
                    </td>
                    <td>
                      <h5
                        className={`${item?.feaIconClass} fs-13 my-1 fw-semiBold`}
                      >
                        {item.amount}
                      </h5>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="align-items-center mt-4 pt-2 justify-content-between row text-center text-sm-start">
            <div className="col-sm">
              <div className="text-muted">
                Showing <span className="fw-semibold">5</span> of{' '}
                <span className="fw-semibold">25</span> Results
              </div>
            </div>
            <div className="col-sm-auto mt-3 mt-sm-0">
              <ul className="pagination pagination-separated pagination-sm mb-0 justify-content-center">
                <li className="page-item disabled">
                  <Link to="#" className="page-link">
                    ←
                  </Link>
                </li>
                <li className="page-item">
                  <Link to="#" className="page-link">
                    1
                  </Link>
                </li>
                <li className="page-item active">
                  <Link to="#" className="page-link">
                    2
                  </Link>
                </li>
                <li className="page-item">
                  <Link to="#" className="page-link">
                    3
                  </Link>
                </li>
                <li className="page-item">
                  <Link to="#" className="page-link">
                    →
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </CardBody> */}
      </Card>
    </React.Fragment>
  );
};

export default RecentTransaction;
